import { FC } from 'react';
import { IMaskInput, IMaskInputProps } from 'react-imask';

export const MaskedInput: FC<IMaskInputProps<HTMLInputElement>> = props => {
  return <IMaskInput {...props} />;
};
